exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail[data-v-d9fc4608]{max-width:760px;margin:0 auto;padding:0 24px;margin-bottom:120px}.detail .content[data-v-d9fc4608]{margin-top:48px}@media screen and (max-width:540px){.detail[data-v-d9fc4608]{margin-bottom:50px}.detail .content[data-v-d9fc4608] p{line-height:25px;text-align:justify}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/workspace/source-code/src/assets","/static":"/workspace/source-code/src/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d9fc4608","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/_lang/html/ceo/index.vue
// module id = UpML
// module chunks = 9